import { useCallback, useContext } from 'react';
import { DialogSettings } from 'src/types/confirm';
import { ConfirmContext, defaultDialogState } from '../contexts/ConfirmContext';

let resolveCallback = (b: boolean) => {};
let rejectCallback = () => {};

const useConfirm = () => {
  const dialogContext = useContext(ConfirmContext);

  const onConfirm = useCallback(() => {
    dialogContext?.setOpen(false);
    dialogContext?.setDefaultDialogSettings();
    resolveCallback(true);
  }, [dialogContext]);

  const onCancel = useCallback(() => {
    dialogContext?.setOpen(false);
    dialogContext?.setDefaultDialogSettings();
    resolveCallback(false);
  }, [dialogContext]);

  const confirm = useCallback(
    (settings: Partial<DialogSettings>) => {
      dialogContext?.setOpen(true);
      dialogContext?.setDefaultDialogSettings();
      dialogContext?.setCurrentDialogSettings({ ...defaultDialogState, ...settings });
      return new Promise<boolean>((res, rej) => {
        resolveCallback = res;
        rejectCallback = rej;
      });
    },
    [dialogContext]
  );

  const onClose = useCallback(() => {
    dialogContext?.setOpen?.(false);
    dialogContext?.setDefaultDialogSettings?.();
    rejectCallback();
  }, [dialogContext]);

  return {
    confirm,
    onConfirm,
    onCancel,
    onClose,
    ...dialogContext,
    rejectCallback,
  };
};

export default useConfirm;
